export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetGameCache(context) {
      context.commit("updateGameCache", false)
    },
  },
  mutations: {
    updateGameCache(state, data) {
      return state.data = data
    }
  }
}